module.exports = __webpack_public_path__ + "2839dfbe735ed7917463e389362c8bfe.svg";